import { lazyNamed } from 'src/utils/lazyNamed.ts';

export const Products = {
  List: lazyNamed(() => import('./containers/ProductsList/index.tsx'), 'ProductsList'),
  Form: lazyNamed(() => import('./containers/ProductForm/index.tsx'), 'ProductForm'),
  ProductHistory: lazyNamed(() => import('./containers/ProductHistory.tsx'), 'ProductHistory'),
};
